import React from "react";
import PropTypes from "prop-types";
import styles from "./Toggle.module.css";

const Toggle = ({
  isOn,
  onToggle,
  onIcon,
  offIcon,
  onLabel,
  offLabel,
  disabled = false,
  size = "medium",
  variant = "default",
  className = "",
  ariaLabel,
  ...props
}) => {
  const handleToggle = () => {
    if (!disabled && onToggle) {
      onToggle(!isOn);
    }
  };

  const sizeClass = styles[size] || styles.medium;
  const variantClass = styles[variant] || styles.default;

  return (
    <button
      className={`${styles.toggleButton} ${className} ${disabled ? styles.disabled : ""}`}
      onClick={handleToggle}
      disabled={disabled}
      aria-label={ariaLabel || (isOn ? onLabel : offLabel)}
      title={ariaLabel || (isOn ? onLabel : offLabel)}
      {...props}
    >
      <div
        className={`${styles.toggleSlider} ${sizeClass} ${variantClass} ${isOn ? styles.on : styles.off}`}
      >
        <div className={`${styles.toggleThumb} ${sizeClass}`}>
          {isOn ? onIcon : offIcon}
        </div>
      </div>
    </button>
  );
};

Toggle.propTypes = {
  isOn: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onIcon: PropTypes.node,
  offIcon: PropTypes.node,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf([
    "default",
    "primary",
    "success",
    "warning",
    "danger",
  ]),
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default Toggle;
